var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60265 2.77273C9.2237 1.74242 10.7763 1.74242 11.3973 2.77273L19.7814 16.6818C20.4025 17.7121 19.6262 19 18.3841 19H1.61592C0.373837 19 -0.402465 17.7121 0.218578 16.6818L8.60265 2.77273Z",
    fill: "#F53500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 13C9.80107 13 9.6103 12.9145 9.46965 12.7623C9.329 12.6102 9.24998 12.4038 9.24998 12.1886L9.24998 6.81144C9.24998 6.59623 9.329 6.38984 9.46965 6.23767C9.6103 6.08549 9.80107 6 9.99998 6C10.1989 6 10.3897 6.08549 10.5303 6.23767C10.671 6.38984 10.75 6.59623 10.75 6.81144L10.75 12.1886C10.75 12.4038 10.671 12.6102 10.5303 12.7623C10.3897 12.9145 10.1989 13 9.99998 13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 14.5C9.44769 14.5 8.99998 14.9477 8.99998 15.5C8.99998 16.0523 9.44769 16.5 9.99998 16.5C10.5523 16.5 11 16.0523 11 15.5C11 14.9477 10.5523 14.5 9.99998 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.e99823264bcecda511944b8adef37d89.svg";
export { ForwardRef as ReactComponent };